import { LandingHome } from "@/components/landing-page/landing-home";
import { useDocumentHead } from "@/lib/document-head";

export function HomePage() {
  useDocumentHead({
    title:
      "Swift MVP | Landing Pages & MVPs Delivered in 24–72 Hours from $99",
    description:
      "Swift MVP builds professional landing pages, brand kits, and hosted web MVPs from your written brief. Flat packages start at $99, delivered live within 24–72 hours, with a money-back guarantee.",
    canonical: "/",
  });
  return <LandingHome />;
}
